












import CollectionSharedFunctions from '../CollectionSharedFunctions'
import Component from 'vue-class-component'
import CollectionOutstandingBalance
  from '@/views/app/management/collections/components/CollectionOutstandingBalance.vue'

@Component({
  components: { CollectionOutstandingBalance }
})
export default class CollectionResidentBalanceInfo extends CollectionSharedFunctions {

}
